/*! No ficheiro theme.liquid da pasta layout, colocar  <script src="{{ 'missuna-gallery.js' | asset_url }}" defer></script> antes do </body>. */

(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 768;
  var ZOOM_SCALE        = 2.5;
  var COLOR_INPUT_SEL   = 'input.swatch-input__input';

  var visibleSlides  = [];
  var currentIndex   = 0;
  var translationMap = {};
  var englishValues  = [];
  var isZoomed       = false;
  var zoomImgCon;

  var style = document.createElement('style');
  style.textContent = `
    .product__slide .product__photo,
    .product__slide img,
    .product__photo img { cursor: default !important; }

    @media (min-width: 769px) {
      .product__slide.missuna-zoom-ready .product__photo,
      .product__slide.missuna-zoom-ready img { cursor: zoom-in !important; }
    }

    .product__slide[data-missuna-hidden] { display: none !important; }

    #missuna-zoom-overlay {
      display: none; position: fixed; inset: 0;
      background: rgba(31, 31, 31, 0.5);
      z-index: 99999; align-items: center; justify-content: center;
    }
    #missuna-zoom-overlay.open { display: flex; animation: mfade .2s ease forwards; }
    @keyframes mfade { from { opacity: 0; } to { opacity: 1; } }

    #missuna-zoom-wrap {
      position: relative; display: flex;
      align-items: center; justify-content: center;
    }

    #missuna-zoom-img-container {
      position: relative;
      overflow: hidden;
      line-height: 0;
    }

    #missuna-zoom-img {
      display: block;
      max-width: 80vw;
      max-height: 88vh;
      width: auto;
      height: auto;
      user-select: none;
      cursor: zoom-in;
      transform-origin: center;
    }

    #missuna-zoom-prev,
    #missuna-zoom-next {
      position: absolute; top: 50%; transform: translateY(-50%);
      background: transparent; border: none;
      color: #FAFAFA; opacity: 1;
      padding: 1rem 0.6rem; cursor: pointer;
      font-size: 1.78rem; line-height: 1;
      z-index: 1;
    }
    #missuna-zoom-prev { left: -2.75rem; }
    #missuna-zoom-next { right: -2.75rem; }
  `;
  document.head.appendChild(style);

  var overlay = document.createElement('div');
  overlay.id = 'missuna-zoom-overlay';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.innerHTML =
    '<div id="missuna-zoom-wrap">' +
      '<button id="missuna-zoom-prev" aria-label="Foto anterior">&#10094;</button>' +
      '<div id="missuna-zoom-img-container">' +
        '<img id="missuna-zoom-img" src="" alt="">' +
      '</div>' +
      '<button id="missuna-zoom-next" aria-label="Foto seguinte">&#10095;</button>' +
    '</div>';
  document.body.appendChild(overlay);

  var zoomImg = document.getElementById('missuna-zoom-img');
  var prevBtn = document.getElementById('missuna-zoom-prev');
  var nextBtn = document.getElementById('missuna-zoom-next');
  zoomImgCon  = document.getElementById('missuna-zoom-img-container');

  function resetZoom() {
    isZoomed = false;
    zoomImg.style.transition      = 'transform 0.2s ease';
    zoomImg.style.transform       = '';
    zoomImg.style.transformOrigin = 'center';
    zoomImg.style.cursor          = 'zoom-in';
  }

  zoomImgCon.addEventListener('click', function (e) {
    e.stopPropagation();

    var rect = zoomImgCon.getBoundingClientRect();
    var xPct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    var yPct = Math.max(0, Math.min(1, (e.clientY - rect.top)  / rect.height));

    if (!isZoomed) {
      isZoomed = true;
      zoomImg.style.transition      = 'transform 0.25s ease';
      zoomImg.style.transformOrigin = (xPct * 100).toFixed(1) + '% ' + (yPct * 100).toFixed(1) + '%';
      zoomImg.style.transform       = 'scale(' + ZOOM_SCALE + ')';
      zoomImg.style.cursor          = 'zoom-out';

      setTimeout(function () {
        zoomImg.style.transition = 'none';
      }, 260);
    } else {
      resetZoom();
    }
  });

  zoomImgCon.addEventListener('mousemove', function (e) {
    if (!isZoomed) return;

    var rect = zoomImgCon.getBoundingClientRect();
    var xPct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    var yPct = Math.max(0, Math.min(1, (e.clientY - rect.top)  / rect.height));

    zoomImg.style.transformOrigin = (xPct * 100).toFixed(1) + '% ' + (yPct * 100).toFixed(1) + '%';
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay || e.target.id === 'missuna-zoom-wrap') fecharZoom();
  });

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getVisibleSlides() {
    return Array.from(document.querySelectorAll(
      '.product__slide[data-type="image"]:not([data-missuna-hidden])'
    ));
  }

  function mostrarImagem(index) {
    var slide = visibleSlides[index];
    var img   = slide ? slide.querySelector('img') : null;

    if (!img) return;

    resetZoom();

    var src = img.getAttribute('src') || img.src;

    zoomImg.src = src.indexOf('//') === 0 ? 'https:' + src : src;
    zoomImg.alt = img.alt || '';
    currentIndex = index;
  }

  function abrirZoom(index) {
    visibleSlides = getVisibleSlides();

    if (!visibleSlides.length) return;

    mostrarImagem(index);
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';

    var temNav = visibleSlides.length > 1;

    prevBtn.style.display = temNav ? '' : 'none';
    nextBtn.style.display = temNav ? '' : 'none';
  }

  function fecharZoom() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    resetZoom();
  }

  function navegar(dir) {
    visibleSlides = getVisibleSlides();
    mostrarImagem((currentIndex + dir + visibleSlides.length) % visibleSlides.length);
  }

  prevBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    navegar(-1);
  });

  nextBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    navegar(1);
  });

  document.addEventListener('keydown', function (e) {
    if (!overlay.classList.contains('open')) return;

    if (e.key === 'Escape')     fecharZoom();
    if (e.key === 'ArrowLeft')  navegar(-1);
    if (e.key === 'ArrowRight') navegar(1);
  });

  function buildTranslationMap(product) {
    var pageValues = [];

    document.querySelectorAll(COLOR_INPUT_SEL).forEach(function (el) {
      var v = el.value ? el.value.trim() : '';

      if (v && pageValues.indexOf(v) === -1) {
        pageValues.push(v);
      }
    });

    var matchingOption = null;

    product.options.forEach(function (opt) {
      if (opt.name.toLowerCase() === 'color' || opt.name.toLowerCase() === 'colour') {
        matchingOption = opt;
      }
    });

    if (!matchingOption) {
      product.options.forEach(function (opt) {
        if (opt.values.length === pageValues.length) {
          matchingOption = opt;
        }
      });
    }

    if (!matchingOption) return;

    englishValues = matchingOption.values.map(function (v) {
      return v.toLowerCase().trim();
    });

    pageValues.forEach(function (t, i) {
      if (englishValues[i]) {
        translationMap[t.toLowerCase().trim()] = englishValues[i];
      }
    });
  }

  function toEnglish(val) {
    var key = val ? val.toLowerCase().trim() : '';

    return translationMap[key] || key;
  }

  function iniciar(product) {
    if (product) buildTranslationMap(product);

    var allSlides = document.querySelectorAll('.product__slide[data-type="image"]');

    if (!allSlides.length) return;

    var valoresCor = englishValues.length ? englishValues : (function () {
      var vals = [];

      document.querySelectorAll(COLOR_INPUT_SEL).forEach(function (el) {
        var v = el.value ? el.value.toLowerCase().trim() : '';

        if (v && vals.indexOf(v) === -1) {
          vals.push(v);
        }
      });

      return vals;
    })();

    allSlides.forEach(function (slide) {
      var img = slide.querySelector('img');

      if (!img) return;

      slide.classList.add('missuna-zoom-ready');

      slide.addEventListener('click', function (e) {
        if (isMobile()) return;

        e.preventDefault();
        e.stopPropagation();

        var idx = getVisibleSlides().indexOf(slide);

        abrirZoom(idx >= 0 ? idx : 0);
      }, true);
    });

    function filtrar(valorCor) {
      var cor = toEnglish(valorCor);

      document.querySelectorAll('.product__slide[data-type="image"]').forEach(function (slide) {
        var img = slide.querySelector('img');
        var alt = (img && img.alt ? img.alt : '').toLowerCase().trim();

        var temCor = valoresCor.some(function (c) {
          return alt.indexOf(c) !== -1;
        });

        if (!temCor || !cor) {
          slide.removeAttribute('data-missuna-hidden');
        } else {
          alt.indexOf(cor) !== -1
            ? slide.removeAttribute('data-missuna-hidden')
            : slide.setAttribute('data-missuna-hidden', '');
        }
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.swatch__button');

      if (!btn) return;

      var input = btn.querySelector(COLOR_INPUT_SEL);

      if (input) filtrar(input.value);
    });

    ['variant:changed', 'variantChange', 'theme:variant-changed'].forEach(function (nome) {
      document.addEventListener(nome, function () {
        var checked = document.querySelector(COLOR_INPUT_SEL + ':checked');

        if (checked) filtrar(checked.value);
      });
    });

    var inicial = document.querySelector(COLOR_INPUT_SEL + ':checked');

    if (inicial) filtrar(inicial.value);
  }

  /* Collection cards: clicar na cor muda o preview; hover nos círculos não muda nada. */

  var collectionProductCache = {};
  var COLLECTION_CARD_SEL = 'grid-item.product-item[data-url], .product-item[data-url]';
  var SHOPIFY_IMAGE_WIDTHS = [136, 160, 180, 220, 254, 284, 292, 320, 480, 528, 640, 720, 960, 1080, 1296, 1512, 1728, 1950];

  function textKey(value) {
    return (value || '').toString().toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function absoluteUrl(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return window.location.protocol + src;
    if (src.indexOf('/') === 0) return window.location.origin + src;

    return src;
  }

  function imageFileName(src) {
    if (!src) return '';

    try {
      var url = new URL(absoluteUrl(src));

      return decodeURIComponent(url.pathname.split('/').pop() || '').toLowerCase();
    } catch (e) {
      return src.split('?')[0].split('/').pop().toLowerCase();
    }
  }

  function imageBaseName(src) {
    return imageFileName(src).replace(/\.[a-z0-9]+$/i, '');
  }

  function shopifyImageUrl(src, width, height, crop) {
    if (!src) return '';

    try {
      var url = new URL(absoluteUrl(src));

      url.searchParams.delete('height');
      url.searchParams.delete('width');
      url.searchParams.delete('crop');

      if (width)  url.searchParams.set('width', width);
      if (height) url.searchParams.set('height', height);
      if (crop)   url.searchParams.set('crop', crop);

      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function setImageSource(img, src, alt) {
    if (!img || !src) return;

    img.setAttribute('src', shopifyImageUrl(src, 2000, 2000, 'center'));

    img.setAttribute('srcset', SHOPIFY_IMAGE_WIDTHS.map(function (w) {
      return shopifyImageUrl(src, w, null, null) + ' ' + w + 'w';
    }).join(', '));

    img.setAttribute('alt', alt || '');
  }

  function extractCodeFromImage(src) {
    var base = imageBaseName(src);
    var parts = base.split('-');
    var code = parts.length ? parts[parts.length - 1] : '';

    return code && code.length <= 6 ? code.toLowerCase() : '';
  }

  function getCardHandle(card) {
    var swatch = card.querySelector('grid-swatch[data-swatch-handle]');

    if (swatch && swatch.getAttribute('data-swatch-handle')) {
      return swatch.getAttribute('data-swatch-handle');
    }

    var rawUrl = card.getAttribute('data-url') || '';
    var link = card.querySelector('a[data-product-link], a.product-link');

    if (!rawUrl && link) {
      rawUrl = link.getAttribute('href') || '';
    }

    var match = rawUrl.match(/\/products\/([^/?#]+)/);

    return match ? match[1] : null;
  }

  function getCardBaseHref(card) {
    var link = card.querySelector('a.product-link[data-product-link], a.product-link');
    var href = link ? (link.getAttribute('href') || link.getAttribute('data-product-link') || '') : '';

    return href.split('?')[0];
  }

  function swatchColorName(btn) {
    var hiddenText = btn.querySelector('[data-swatch-text], .visually-hidden');

    var name = btn.getAttribute('data-tooltip') ||
      (hiddenText ? hiddenText.textContent : '') ||
      btn.getAttribute('data-swatch-variant-name') ||
      '';

    if (name.indexOf('/') !== -1) {
      name = name.split('/').pop();
    }

    return name.trim();
  }

  function getCardColors(card) {
    var colors = [];
    var seen = {};

    card.querySelectorAll('[data-swatch-button]').forEach(function (btn) {
      var name = swatchColorName(btn);

      if (!name) return;

      var key = textKey(name);

      if (seen[key]) return;

      seen[key] = true;

      var swatchImage = btn.getAttribute('data-swatch-image') || '';

      colors.push({
        name: name,
        key: key,
        code: extractCodeFromImage(swatchImage),
        image: swatchImage,
        imageFile: imageFileName(swatchImage),
        variantId: btn.getAttribute('data-swatch-variant') || btn.getAttribute('data-variant') || ''
      });
    });

    if (!colors.length) {
      var holder = card.querySelector('grid-swatch[data-swatch-values]');
      var values = holder ? holder.getAttribute('data-swatch-values') : '';

      values.split(',').forEach(function (item) {
        var name = (item.split(':')[0] || '').trim();
        var key = textKey(name);

        if (name && !seen[key]) {
          seen[key] = true;

          colors.push({
            name: name,
            key: key,
            code: '',
            image: '',
            imageFile: '',
            variantId: ''
          });
        }
      });
    }

    return colors;
  }

  function getColorByKey(colors, key) {
    key = textKey(key);

    for (var i = 0; i < colors.length; i++) {
      if (colors[i].key === key) {
        return colors[i];
      }
    }

    return null;
  }

  function imageColorKeys(item, colors) {
    var keys = [];
    var alt = textKey(item.alt || '');
    var base = imageBaseName(item.src || '');

    colors.forEach(function (color) {
      var hasName = color.key && alt.indexOf(color.key) !== -1;

      var hasCode = color.code && (
        base === color.code ||
        base.indexOf('-' + color.code) !== -1 ||
        base.indexOf('_' + color.code) !== -1
      );

      if ((hasName || hasCode) && keys.indexOf(color.key) === -1) {
        keys.push(color.key);
      }
    });

    return keys;
  }

  function imageBelongsToColor(item, activeColorKey, colors) {
    if (!activeColorKey) return true;

    var keys = imageColorKeys(item, colors);

    if (!keys.length) return true;

    return keys.indexOf(activeColorKey) !== -1;
  }

  function colorFromImage(item, colors) {
    var keys = imageColorKeys(item, colors);

    return keys.length ? keys[0] : '';
  }

  function collectDomAltMap(card) {
    var map = {};

    card.querySelectorAll('img').forEach(function (img) {
      var src = img.getAttribute('src') || img.src || '';
      var file = imageFileName(src);

      if (file && img.alt) {
        map[file] = img.alt;
      }
    });

    return map;
  }

  function mediaSrc(media) {
    if (!media) return '';
    if (typeof media === 'string') return media;
    if (media.src) return media.src;
    if (media.preview_image && media.preview_image.src) return media.preview_image.src;
    if (media.image && media.image.src) return media.image.src;

    return '';
  }

  function mediaAlt(media) {
    if (!media || typeof media === 'string') return '';

    return media.alt ||
      (media.preview_image && media.preview_image.alt) ||
      (media.image && media.image.alt) ||
      '';
  }

  function getProductMedia(product, card) {
    var items = [];
    var seen = {};
    var domAltMap = collectDomAltMap(card);

    function add(src, alt) {
      if (!src) return;

      var file = imageFileName(src);

      if (!file || seen[file]) return;

      seen[file] = true;

      items.push({
        src: src,
        alt: alt || domAltMap[file] || ''
      });
    }

    if (product && product.media && product.media.length) {
      product.media.forEach(function (m) {
        if (m.media_type && m.media_type !== 'image') return;

        add(mediaSrc(m), mediaAlt(m));
      });
    }

    if (!items.length && product && product.images && product.images.length) {
      product.images.forEach(function (src) {
        add(src, '');
      });
    }

    if (product && product.variants && product.variants.length) {
      product.variants.forEach(function (variant) {
        if (!variant.featured_image) return;

        var src = mediaSrc(variant.featured_image);
        var file = imageFileName(src);
        var alt = mediaAlt(variant.featured_image) || variant.title || '';

        items.forEach(function (item) {
          if (imageFileName(item.src) === file && !item.alt) {
            item.alt = alt;
          }
        });
      });
    }

    if (!items.length) {
      card.querySelectorAll('.product-item__bg img, [data-hover-slider] img').forEach(function (img) {
        add(img.getAttribute('src') || img.src || '', img.alt || '');
      });
    }

    return items;
  }

  function fetchCollectionProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (collectionProductCache[handle]) return collectionProductCache[handle];

    collectionProductCache[handle] = fetch('/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed');

        return response.json();
      })
      .catch(function () {
        return null;
      });

    return collectionProductCache[handle];
  }

  function findStartIndex(media, activeColorKey, colors, currentImageFile) {
    var i;

    if (currentImageFile) {
      for (i = 0; i < media.length; i++) {
        if (imageFileName(media[i].src) === currentImageFile) {
          return i;
        }
      }
    }

    for (i = 0; i < media.length; i++) {
      var keys = imageColorKeys(media[i], colors);

      if (keys.length && keys.indexOf(activeColorKey) !== -1) {
        return i;
      }
    }

    return 0;
  }

  function chooseMainImage(media, activeColorKey, colors, activeColor) {
    var i;

    if (activeColor && activeColor.imageFile) {
      for (i = 0; i < media.length; i++) {
        if (imageFileName(media[i].src) === activeColor.imageFile) {
          return media[i];
        }
      }
    }

    for (i = 0; i < media.length; i++) {
      var keys = imageColorKeys(media[i], colors);

      if (keys.length && keys.indexOf(activeColorKey) !== -1) {
        return media[i];
      }
    }

    return media[0] || null;
  }

  function chooseHoverImage(media, activeColorKey, colors, currentImageFile) {
    if (!media.length) return null;

    var startIndex = findStartIndex(media, activeColorKey, colors, currentImageFile);
    var total = media.length;
    var i;
    var idx;
    var item;

    for (i = 1; i <= total; i++) {
      idx = (startIndex + i) % total;
      item = media[idx];

      if (currentImageFile && imageFileName(item.src) === currentImageFile) continue;

      if (imageBelongsToColor(item, activeColorKey, colors)) {
        return item;
      }
    }

    for (i = 0; i < total; i++) {
      if (imageBelongsToColor(media[i], activeColorKey, colors)) {
        return media[i];
      }
    }

    return media[startIndex] || media[0];
  }

  function getDefaultImage(card) {
    return card.querySelector('[data-product-image-default] > figure img') ||
      card.querySelector('[data-product-image-default] img') ||
      card.querySelector('.product-item__bg img') ||
      card.querySelector('[data-product-image] img');
  }

  function defaultColorForCard(card, colors) {
    var img = getDefaultImage(card);

    var key = img
      ? colorFromImage({
          src: img.getAttribute('src') || img.src || '',
          alt: img.alt || ''
        }, colors)
      : '';

    return key || (colors[0] ? colors[0].key : '');
  }

  function ensureHoverImg(card) {
    var img = card.querySelector('.product-item__bg__slide[data-hover-slide] img');

    if (img) return img;

    var slider = card.querySelector('[data-hover-slider]');

    if (!slider) return null;

    var firstSlide = slider.querySelector('.product-item__bg__slide');

    if (!firstSlide) return null;

    var clone = firstSlide.cloneNode(true);

    clone.setAttribute('data-hover-slide', '');
    slider.appendChild(clone);

    return clone.querySelector('img');
  }

  function updateCardProductLinks(card) {
    var data = card._missunaCollection;

    if (!data) return;

    var href = data.baseHref || '';

    if (!href) return;

    if (data.activeVariantId) {
      href += '?variant=' + data.activeVariantId;
    }

    card.querySelectorAll('a.product-link, a[data-product-link]').forEach(function (link) {
      if (link.hasAttribute('data-swatch-link')) return;

      link.setAttribute('href', href);
    });
  }

  function setCollectionCardMainImage(card) {
    var data = card._missunaCollection;

    if (!data || !data.colors.length) return;

    var media = data.media && data.media.length ? data.media : getProductMedia(null, card);

    if (!media.length) return;

    var activeColorKey = data.activeColorKey || data.defaultColorKey;
    var activeColor = getColorByKey(data.colors, activeColorKey);
    var mainImage = chooseMainImage(media, activeColorKey, data.colors, activeColor);

    if (!mainImage) return;

    data.currentMainImage = mainImage;

    if (activeColor && activeColor.variantId) {
      data.activeVariantId = activeColor.variantId;
    }

    card.querySelectorAll('[data-product-image-default] img, .product-item__bg__inner img').forEach(function (img) {
      setImageSource(img, mainImage.src, mainImage.alt || img.alt || '');
    });

    updateCardProductLinks(card);
  }

  function updateCollectionCardHover(card) {
    var data = card._missunaCollection;

    if (!data || !data.colors.length) return;

    var media = data.media && data.media.length ? data.media : getProductMedia(null, card);

    if (!media.length) return;

    var activeColorKey = data.activeColorKey || data.defaultColorKey;
    var activeColor = getColorByKey(data.colors, activeColorKey);
    var currentImageFile = '';

    if (activeColor && activeColor.imageFile) {
      currentImageFile = activeColor.imageFile;
    } else if (data.currentMainImage) {
      currentImageFile = imageFileName(data.currentMainImage.src);
    } else {
      var defaultImg = getDefaultImage(card);

      currentImageFile = defaultImg ? imageFileName(defaultImg.getAttribute('src') || defaultImg.src || '') : '';
    }

    var chosen = chooseHoverImage(media, activeColorKey, data.colors, currentImageFile);

    if (!chosen) return;

    var hoverImg = ensureHoverImg(card);

    if (!hoverImg) return;

    setImageSource(hoverImg, chosen.src, chosen.alt || hoverImg.alt || '');
  }

  function activateCollectionCardColor(card, colorKey) {
    var data = card._missunaCollection;

    if (!data) return;

    data.activeColorKey = colorKey || data.defaultColorKey;

    setCollectionCardMainImage(card);
    updateCollectionCardHover(card);
  }

  function restoreCollectionCardAfterSwatchHover(card) {
    window.requestAnimationFrame(function () {
      setCollectionCardMainImage(card);
      updateCollectionCardHover(card);

      setTimeout(function () {
        setCollectionCardMainImage(card);
        updateCollectionCardHover(card);
      }, 60);
    });
  }

  function stopSwatchEvent(e) {
    e.preventDefault();
    e.stopPropagation();

    if (e.stopImmediatePropagation) {
      e.stopImmediatePropagation();
    }
  }

  function initCollectionCard(card) {
    if (!card || card.hasAttribute('data-missuna-collection-ready')) return;

    card.setAttribute('data-missuna-collection-ready', 'true');

    var handle = getCardHandle(card);
    var colors = getCardColors(card);

    if (!handle || !colors.length) return;

    card._missunaCollection = {
      handle: handle,
      colors: colors,
      defaultColorKey: defaultColorForCard(card, colors),
      activeColorKey: '',
      activeVariantId: '',
      baseHref: getCardBaseHref(card),
      media: [],
      currentMainImage: null
    };

    card._missunaCollection.activeColorKey = card._missunaCollection.defaultColorKey;

    var initialColor = getColorByKey(colors, card._missunaCollection.activeColorKey);

    if (initialColor && initialColor.variantId) {
      card._missunaCollection.activeVariantId = initialColor.variantId;
    }

    fetchCollectionProduct(handle).then(function (product) {
      if (!card._missunaCollection) return;

      card._missunaCollection.media = getProductMedia(product, card);

      setCollectionCardMainImage(card);
      updateCollectionCardHover(card);
    });

    var imageArea = card.querySelector('[data-product-image]');

    if (imageArea) {
      imageArea.addEventListener('mouseenter', function () {
        setCollectionCardMainImage(card);
        updateCollectionCardHover(card);
      });

      imageArea.addEventListener('focusin', function () {
        setCollectionCardMainImage(card);
        updateCollectionCardHover(card);
      });
    }

    card.querySelectorAll('[data-swatch-button]').forEach(function (btn) {
      var name = swatchColorName(btn);
      var key = textKey(name);

      if (!key) return;

      btn.addEventListener('mouseover', function (e) {
        e.stopPropagation();

        if (e.stopImmediatePropagation) {
          e.stopImmediatePropagation();
        }

        restoreCollectionCardAfterSwatchHover(card);
      }, true);

      btn.addEventListener('mouseenter', function (e) {
        e.stopPropagation();

        if (e.stopImmediatePropagation) {
          e.stopImmediatePropagation();
        }

        restoreCollectionCardAfterSwatchHover(card);
      }, true);

      btn.addEventListener('pointerover', function (e) {
        e.stopPropagation();

        if (e.stopImmediatePropagation) {
          e.stopImmediatePropagation();
        }

        restoreCollectionCardAfterSwatchHover(card);
      }, true);

      btn.addEventListener('focusin', function (e) {
        e.stopPropagation();

        if (e.stopImmediatePropagation) {
          e.stopImmediatePropagation();
        }

        restoreCollectionCardAfterSwatchHover(card);
      }, true);

      btn.addEventListener('click', function (e) {
        stopSwatchEvent(e);
        activateCollectionCardColor(card, key);

        return false;
      }, true);
    });
  }

  function iniciarCollectionCards() {
    document.querySelectorAll(COLLECTION_CARD_SEL).forEach(initCollectionCard);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (node.matches && node.matches(COLLECTION_CARD_SEL)) {
            initCollectionCard(node);
          }

          if (node.querySelectorAll) {
            node.querySelectorAll(COLLECTION_CARD_SEL).forEach(initCollectionCard);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  var pathMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
  var handle    = pathMatch ? pathMatch[1] : null;

  function run(product) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        iniciar(product);
        iniciarCollectionCards();
      });
    } else {
      iniciar(product);
      iniciarCollectionCards();
    }
  }

  if (handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (p) {
        run(p);
      })
      .catch(function () {
        run(null);
      });
  } else {
    run(null);
  }

}());
